export default "__VITE_ASSET__0eID9CJ1__"